export default {
      id: "icon-sign-out-usage",
      viewBox: "0 0 18.7 17.1",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-sign-out",
      toString: function () {
        return this.url;
      }
    }